import { createContext } from 'react';

import { PatientDocsState } from './patient-docs.model';

export const PatientDocsContext = createContext<PatientDocsState | undefined>(undefined);

PatientDocsContext.displayName = 'PatientDocsContext';
